import React from 'react';
import uniqueId from 'lodash/uniqueId';
import { AttributeIcon, IcnArrowR } from '../../themes/icons/attributes';
var PdpAttributes = function (_a) {
    var plantData = _a.plantData, data = _a.data;
    var title = plantData.title;
    var getRange = function (attr) {
        var id1 = "".concat(attr[0].attr_value.replace(/ /g, '_'));
        if (attr.length > 1) {
            var id2 = "".concat(attr[attr.length - 1].attr_value.replace(/ /g, '_'));
            return (React.createElement("h3", null,
                React.createElement(AttributeIcon, { name: id1, className: "icn" }),
                React.createElement(IcnArrowR, { className: "divider" }),
                React.createElement(AttributeIcon, { name: id2, className: "icn" })));
        }
        return (React.createElement("h3", null,
            React.createElement(AttributeIcon, { name: id1, className: "icn" })));
    };
    var getWaterRange = function (attr, index) {
        // special function because we're isolating dry in winter/summer/dormant
        var singleAttr = [];
        var rangeAttr = [];
        var elemList = [];
        attr.attr_values.forEach(function (item) {
            if (item.attr_value === 'dry in winter'
                || item.attr_value === 'dry in summer'
                || item.attr_value === 'dry when dormant') {
                singleAttr.push(item);
            }
            else {
                rangeAttr.push(item);
            }
        });
        if (rangeAttr.length > 1) {
            var id1 = "".concat(rangeAttr[0].attr_value.replace(/ /g, '_'));
            var id2 = "".concat(rangeAttr[rangeAttr.length - 1].attr_value.replace(/ /g, '_'));
            var valuesRange = rangeAttr[0].attr_value;
            if (rangeAttr.length > 1) {
                valuesRange += " - ".concat(rangeAttr[rangeAttr.length - 1].attr_value);
            }
            var values = React.createElement("li", null, valuesRange);
            var elem = (React.createElement("li", { key: index },
                React.createElement("h3", null,
                    React.createElement(AttributeIcon, { name: id1, className: "icn" }),
                    React.createElement(IcnArrowR, { className: "divider" }),
                    React.createElement(AttributeIcon, { name: id2, className: "icn" })),
                React.createElement("h4", null, attr.attr_name),
                React.createElement("ul", { className: "pdp_details__list-conditions" }, values)));
            elemList.push(elem);
        }
        else if (rangeAttr.length === 1) {
            var id1 = "".concat(rangeAttr[0].attr_value.replace(/ /g, '_'));
            var elem = (React.createElement("li", { key: index },
                React.createElement("h3", null,
                    React.createElement(AttributeIcon, { name: id1, className: "icn" })),
                React.createElement("h4", null, attr.attr_name),
                React.createElement("ul", { className: "pdp_details__list-conditions" },
                    React.createElement("li", { key: "0" }, rangeAttr[0].attr_value))));
            elemList.push(elem);
        }
        if (singleAttr.length > 0) {
            singleAttr.forEach(function (item) {
                var attrId = "".concat(item.attr_value.replace(/ /g, '_'));
                var elem = (React.createElement("li", { key: item.attr_pk_value },
                    React.createElement("h3", null,
                        React.createElement(AttributeIcon, { name: attrId, className: "icn" })),
                    React.createElement("h4", null, attr.attr_name),
                    React.createElement("ul", { className: "pdp_details__list-conditions" },
                        React.createElement("li", null, item.attr_value))));
                elemList.push(elem);
            });
        }
        return elemList;
    };
    var getAttr = function (attr) {
        var attrArray = attr.map(function (item, index) {
            var values = item.attr_values.map(function (node) { return (React.createElement("li", { key: uniqueId(node.attr_value) }, node.attr_value)); });
            if (item.attr_name === 'Sun Exposure') {
                var header = getRange(item.attr_values);
                var valuesRange = item.attr_values[0].attr_value;
                if (item.attr_values.length > 1) {
                    valuesRange
                        += " - ".concat(item.attr_values[item.attr_values.length - 1].attr_value);
                }
                values = React.createElement("li", null, valuesRange);
                return (React.createElement("li", { key: uniqueId(item.attr_name) },
                    header,
                    React.createElement("h4", null, item.attr_name),
                    React.createElement("ul", { className: "pdp_details__list-conditions" }, values)));
            }
            if (item.attr_name === 'Water Needs') {
                return getWaterRange(item, index);
            }
            var attrId = "attr".concat(item.pk_value);
            return (React.createElement("li", { key: uniqueId(item.attr_name) },
                React.createElement("h3", null,
                    React.createElement(AttributeIcon, { name: attrId, className: "icn" })),
                React.createElement("h4", null, item.attr_name),
                React.createElement("ul", { className: "pdp_details__list-conditions" }, values)));
        });
        return attrArray;
    };
    var gcArray = [];
    var fsArray = [];
    data.forEach(function (item) {
        if (item.attr_type === 'Growing Conditions') {
            gcArray.push(item);
        }
        if (item.attr_type === 'Features'
            && item.attr_name !== 'Plant Type') {
            fsArray.push(item);
        }
    });
    var fsArrayElements = getAttr(fsArray);
    var gcArrayElements = getAttr(gcArray);
    return (React.createElement("div", { className: "pdp_details__2" },
        React.createElement("div", { className: "column" },
            React.createElement("h3", null, "How to Grow ".concat(title)),
            React.createElement("ul", { className: "grid pdp_details__list-attributes" }, gcArrayElements)),
        React.createElement("div", { className: "column" },
            React.createElement("h3", null, "Features"),
            React.createElement("ul", { className: "grid pdp_details__list-attributes" }, fsArrayElements))));
};
export default PdpAttributes;
